import { fromJS } from 'immutable';
import * as constants from './contract-list-constants';
import R from 'ramda';

const initialState = fromJS({
  selectedContracts: [], // ids
  allContractIds: [], // all ids for the search
  list: {
    listType: 'Recent',
    loading: true,
    dataToShow: [],
    page: 1,
    totalPages: 1,
    loadingText: '',
  },
  searchParams: {
    openAdvanceSearch: false,
    isFolder: false,
    stateFilterForBuyer: [], // ['sent', 'received', 'accepted', 'rejected', 'loaded', 'loading'],
    stateFilterForSupplier: [], // ['request', 'sent', 'accepted', 'rejected', 'loaded', 'loading'],
    contractTypeFilter: [], // ['tc', 'external'], // tc, external
    rateConversionStatusFilter: [],
    sentFilter: [], // ['bounced', 'delivered', 'opened'],
    readUnreadFilter: [], // ['read', 'unread'], // read, unread
    searchInput: '',
    newActivity: false,
    companySearchInput: '',
    locationSearchInput: '',
    searchCategory: 'all contracts',
    searchingAllYears: true,
    sortValue: 'updatedAt', // activity, endDate, updatedAt
    sortRule: -1,
    otherSideRead: [],
    showRateContainers: false,
    showArchivedDeleted: false,
  },
  folderLoading: false,
  folders: [],
  selectedFolders: [],
  manageFolderDialogOpen: false,
  startPolling: false,
  bulkResendDialog: {
    partners: [],
    open: false,
    customizedMessage: '',
    subject: '',
  },
  getContractEmailStatus: {},
});

function contractList(state = initialState, { type, payload, ...extraPayload }) {
  switch (type) {
    case '[contract-list]CHANGE_ROUTE':
      return state.setIn(['list', 'listType'], payload.routeName)
                  .setIn(['list', 'dataToShow'], fromJS([]))
                  .set('pathBeforeSearch', '')
                  .set('isFolder', payload.isFolder)
                  .set('searchParams',
                    initialState.get('searchParams')
                                .set('searchingAllYears', state.getIn(['searchParams', 'searchingAllYears']))
                                .set('isFolder', payload.isFolder)
                                .set('searchCategory', payload.routeName)
                  );
    case '[contracting]SELECTED_YEAR_FOR_CONTRACTING':
      if (extraPayload.currentRoute && extraPayload.currentRoute.indexOf('contract-list') > -1) return state.setIn(['searchParams', 'searchingAllYears'], false);
      return state;
    case constants.UPDATE_PARAMS:
      return state.update('searchParams', searchParams => searchParams.merge(fromJS(payload)));
    case constants.RESET_PARAMS:
      return state.set('searchParams', initialState.get('searchParams').set('searchingAllYears', state.getIn(['searchParams', 'searchingAllYears'])));
    case constants.DOWNLOADING_PDF_ZIP:
      return state.set('selectedContracts', fromJS([]))
        .setIn(['list', 'loading'], true)
        .setIn(['list', 'loadingText'], `Please be patient, as this download may take a few minutes.\n\n\nWhile you wait...\n\n\nFun Fact: QANTAS, the name for Australia’s national airline, was originally an acronym for Queensland and Northern Territories Air Service.  It was founded in Winton, Queensland on 16 November 1920.`);
    case constants.PDF_ZIP_DOWNLOADED:
      return state.setIn(['list', 'loading'], false)
      .setIn(['list', 'loadingText'], '');
    case constants.LOADING_LIST:
      return state.setIn(['list', 'loading'], payload).set('startPolling', true);
    case `${constants.LOAD_CONTRACT_LIST}_STARTED`:
      return state.setIn(['list', 'loading'], true).set('startPolling', true);
    case `${constants.LOAD_CONTRACT_LIST}_SUCCESS`:
      return state.set('outBoxCount', payload.outBoxCount)
        .set('bouncedCount', payload.bouncedCount)
        .set('rcCount', payload.rcCount)
        .update('list', list => {
          const toBeMerged = { loading: false, dataToShow: payload.list, page: payload.page, listType: payload.listType };
          if (payload.totalPages) toBeMerged.totalPages = payload.totalPages;
          return list.merge(fromJS(toBeMerged));
        })
        .set('startPolling', false);
    case `${constants.GET_MORE_CONTRACT_INFO}_SUCCESS`:
      return state.updateIn(['list', 'dataToShow'], contracts => contracts.map(contract => {
        if (contract.get('_id') === extraPayload.args[0].docId) {
          return contract.merge(fromJS(payload));
        }
        return contract;
      }))
        .set('startPolling', false);
    case constants.SELECT_CURRENT_ALL:
      return state.set('selectedContracts',
        state.getIn(['list', 'dataToShow'])
             .filter(contract => R.contains('read', contract.get('access')))
             .map(contract => contract.get('_id')))
        .set('allContractIds', fromJS(payload.allContractIds));
    case constants.STATE_CHANGE:
      return state.updateIn(['list', 'dataToShow'], contracts =>
        contracts.map(contract => {
          const stateKey = contract.get('locationId') ? 'state' : 'rateConversionStatus';
          return R.contains(contract.get('_id'), payload.contractIds) ? contract.set(stateKey, payload.newState) : contract;
        }));
    case constants.MARK_AS_RECEIVED:
      return state.updateIn(['list', 'dataToShow'], contracts =>
        contracts.map(contract => R.contains(contract.get('_id'), payload.contractIds) ? contract.set('buyerChecked', true) : contract));
    case `${constants.UPDATE_FOLDER_NAME}_SUCCESS`:
      return state.merge(fromJS({
        folderToBeRenamedIndex: undefined,
        renameFolderError: undefined,
        originalFolder: undefined,
        newFolderName: undefined,
      }));
    case constants.UPDATE_FOLDER_NAME:
    case constants.UPDATE_PROPS:
      return state.merge(fromJS(payload));
    case constants.SELECT_ONE_CONTRACT:
      return state.set('selectedContracts', removeOrAddId(state.get('selectedContracts'), payload));
    case constants.MASS_ASSIGN_FOLDER:
      return state.set('selectedContracts', fromJS([]));
    case constants.MASS_ARCHIVE_OR_RESTORE:
    case constants.MASS_DELETE_RESTORE:
      return state.set('selectedContracts', fromJS([]))
        .setIn(['list', 'dataToShow'], state.getIn(['list', 'dataToShow']).filter(contract => !R.contains(contract.get('_id'), payload.contractIds)));
    case constants.CREATE_FOLDER:
      return state.update('folders', folders => folders.push(payload))
        .set('newFolderName', '')
        .set('createNewFolder', false);
    case constants.DELETE_FOLDER:
      return state.update('folders', folders => fromJS(folders.filter(folder => folder !== payload)));
    case constants.TOGGLE_BULK_RESEND_DIALOG:
      if (!payload) return state.set('bulkResendDialog', initialState.get('bulkResendDialog'));
      return state.setIn(['bulkResendDialog', 'open'], payload);
    case constants.POPULATE_BULK_RESEND:
      return state.update('bulkResendDialog', dialog => dialog.merge(fromJS(payload)));
    case constants.BULK_SENDING:
      return state.setIn(['bulkResendDialog', 'sending'], true);
    case constants.BULK_SEND_FINISHED:
      return state.setIn(['bulkResendDialog', 'sending'], false).setIn(['bulkResendDialog', 'sent'], true).set('selectedContracts', fromJS([]));
    case constants.UPDATE_BULK_RESEND_PROPS:
      return state.update('bulkResendDialog', bulkResendDialog => bulkResendDialog.merge(fromJS(payload)));
    case constants.GET_CONTRACT_EMAIL:
      return state.setIn(['contractMailboxes', payload, 'loading'], true);
    case `${constants.GET_CONTRACT_EMAIL}_SUCCESS`:
      return state.setIn(['contractMailboxes', payload.contractId], fromJS({ mailbox: payload.mailbox }));
    case '[contract-request]GET_RESPONDED_CONTRACT_LIST_SUCCESS':
      return state.setIn(['list', 'dataToShow'], fromJS([...payload.list.map(o => ({ ...o, access: ['read', 'write'] }))]))
        .setIn(['list', 'loading'], false);
    default:
      return state;
  }
}

const removeOrAddId = (originalSelectedContracts, id) => {
  const originalSelectedContractsJS = originalSelectedContracts.toJS();
  const indexOfId = R.indexOf(id, originalSelectedContractsJS);
  if (indexOfId > -1) return fromJS(R.remove(indexOfId, 1, originalSelectedContractsJS));
  return fromJS(R.append(id, originalSelectedContractsJS));
};

export default contractList;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/contract-list/contract-list-reducer.js